import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SqsPageHeader, SqsButton } from './sqs/SqsShell';
import { Sparkles, Plus, BookOpen, Users, Lock, Globe } from 'lucide-react';
import { toast } from 'sonner';

export default function DashboardContentMemberships() {
  const navigate = useNavigate();
  const items = [
    { id: 'blog',      icon: BookOpen, title: 'Blog',             desc: 'Publish articles, news, and stories to bring traffic to your site.',  go: () => navigate('/website-builder/pages')  },
    { id: 'members',   icon: Users,    title: 'Members area',     desc: 'Build a private space for paying subscribers.',                       go: () => toast('Members area coming soon — for now create a Page with gated content.') },
    { id: 'gated',     icon: Lock,     title: 'Gated content',    desc: 'Lock specific pages and content behind a paywall.',                   go: () => navigate('/website-builder/selling-tools') },
    { id: 'community', icon: Globe,    title: 'Community feed',   desc: 'Let your members post, comment, and connect.',                        go: () => window.open('/feed', '_blank') },
  ];
  return (
    <>
      <SqsPageHeader
        breadcrumbs="Content"
        title="Content & Memberships"
        subtitle="Publish gated content, sell digital products, and run a subscriber community."
        actions={<SqsButton variant="primary" size="sm" icon={Plus} onClick={() => navigate('/website-builder/pages')} data-testid="content-add-btn">Create Content</SqsButton>}
      />
      <div className="p-10 max-w-6xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map(t => (
          <div key={t.id} className="bg-[#15152E] border border-white/[0.06] rounded-xl p-6 hover:border-white/[0.16] transition-all" data-testid={`cm-${t.id}`}>
            <div className="w-10 h-10 rounded-lg bg-[#A78BFA]/10 flex items-center justify-center mb-4">
              <t.icon size={18} className="text-[#A78BFA]" />
            </div>
            <h3 className="text-[14.5px] font-bold text-white mb-2">{t.title}</h3>
            <p className="text-[12px] text-[#9CA3AF] leading-relaxed mb-4">{t.desc}</p>
            <button
              onClick={t.go}
              className="text-[10.5px] uppercase tracking-[0.18em] text-[#A78BFA] font-bold hover:text-white"
              data-testid={`cm-${t.id}-btn`}
            >
              Set up →
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
